<template>
<div class="component enaq-flip-container  tile is-child ">

    <div class="enaq-flip-inner" :style="innerflipstyle">
        <div class="flip-card-front enaq-flip " @click="flipped = true" :style='frontStyle'>
            <slot name="front"></slot>
        </div>
        <div class="flip-card-back enaq-flip" :style="backStyle" >
              <div class="flipModalContainer"> <span class="flipModalIcon"><i class="fas fa-undo" @click="flipped =false"></i></span>
</div>
            <slot name="back"></slot>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'fliptile',
    props: ["height"],
    mounted: function () {
if(this.height!=null&&this.height!=undefined){
    this.tileHeight = this.height;
}else{
    this.tileHeight = '100px';
}
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            flipped: false,
            frontstyle: '',
            backstyle: '',
            tileHeight:''
        }
    },
    methods: {},
    computed: {
        innerflipstyle() {
            let styleData = {
                'min-height': this.tileHeight
            }

            if (this.flipped) {
                styleData['transform'] = 'rotateY(180deg)';
                styleData['webkit-transform'] = 'rotateY(180deg)';

            }

            return styleData;

        },
        frontStyle() {
            return;
            if (this.flipped) {
                return {
                    display: 'none'
                }
            }
        },
        backStyle() {
            return;
            if (!this.flipped) {
                return {
                    display: 'none'
                }
            }
        }
    }
}
</script>

<style scoped>
.tile .is-child.enaq-flip-container {
    background: none !important;
    background-color: transparent;
    perspective: 10000px;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    -webkit-transform: rotateZ(360deg);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;

}

.enaq-flip-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    -webkit-transition: transform 0.8s;

}

.flip-card-back:nth-child(2) {}

.flip-card-front,
.flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    overflow: hidden;

}

.flip-card-front *,
.flip-card-back * {

    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}

.flip-card-front {
    color: black;
}

.flip-card-back {
    color: white;
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
}

.flip-card-back:first.child {
    padding-right: 200px;
}

.flipModalContainer {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 1.5em;
    line-height: 2em;
    color: white;
    padding: 0 10px;
    background: #3E9BD7;
    max-height: calc(2em - 5px);
    border-radius: 40px;
    z-index: 999;
}

.enaq-flip>* {
    height: 100%;
}
</style>
